import Uppy from '@uppy/core';
import { Template } from '@utils/types/organization/export-template.ts';
import { Language } from '@utils/types/shared/language.ts';

export type State = {
  selectedLanguage: Language | null;
  uploading: boolean;
  isPaused: boolean;
  resultUppy: unknown | null;
  uppy: Uppy | null;
  alignmentMediaFile: File | null;
  alignmentTranscriptFile: File | null;
  alignmentProgress: number;
  hasFiles: boolean;
  azureBlobProgress: number;
  isRecording: boolean;
  minSpeakers: number | null;
  maxSpeakers: number | null;
  selectedExportTemplate: Template | null;
};

export type Action = {
  type:
    | 'SET_SELECTED_LANGUAGE'
    | 'SET_UPLOADING'
    | 'SET_IS_PAUSED'
    | 'SET_RESULT_UPPY'
    | 'SET_UPPY'
    | 'SET_ALIGNMENT_MEDIA_FILE'
    | 'SET_ALIGNMENT_TRANSCRIPT_FILE'
    | 'SET_ALIGNMENT_PROGRESS'
    | 'SET_HAS_FILES'
    | 'SET_AZURE_BLOB_PROGRESS'
    | 'SET_IS_RECORDING'
    | 'SET_MIN_SPEAKERS'
    | 'SET_MAX_SPEAKERS'
    | 'SET_SELECTED_EXPORT_TEMPLATE';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Language | boolean | any | Uppy | File | number | Template | null;
};

export const initialState: State = {
  selectedLanguage: null,
  uploading: false,
  isPaused: false,
  resultUppy: null,
  uppy: null,
  alignmentMediaFile: null,
  alignmentTranscriptFile: null,
  alignmentProgress: 0,
  hasFiles: false,
  azureBlobProgress: 0,
  isRecording: false,
  minSpeakers: null,
  maxSpeakers: null,
  selectedExportTemplate: null
};

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'SET_SELECTED_LANGUAGE':
      return { ...state, selectedLanguage: action.payload as Language };
    case 'SET_UPLOADING':
      return { ...state, uploading: action.payload as boolean };
    case 'SET_IS_PAUSED':
      return { ...state, isPaused: action.payload as boolean };
    case 'SET_RESULT_UPPY':
      return { ...state, resultUppy: action.payload };
    case 'SET_UPPY':
      return { ...state, uppy: action.payload as Uppy };
    case 'SET_ALIGNMENT_MEDIA_FILE':
      return { ...state, alignmentMediaFile: action.payload as File | null };
    case 'SET_ALIGNMENT_TRANSCRIPT_FILE':
      return {
        ...state,
        alignmentTranscriptFile: action.payload as File | null
      };
    case 'SET_ALIGNMENT_PROGRESS':
      return { ...state, alignmentProgress: action.payload as number };
    case 'SET_HAS_FILES':
      return { ...state, hasFiles: action.payload as boolean };
    case 'SET_AZURE_BLOB_PROGRESS':
      return { ...state, azureBlobProgress: action.payload as number };
    case 'SET_IS_RECORDING':
      return { ...state, isRecording: action.payload as boolean };
    case 'SET_MIN_SPEAKERS':
      return { ...state, minSpeakers: action.payload as number | null };
    case 'SET_MAX_SPEAKERS':
      return { ...state, maxSpeakers: action.payload as number | null };
    case 'SET_SELECTED_EXPORT_TEMPLATE':
      return {
        ...state,
        selectedExportTemplate: action.payload as Template | null
      };
    default:
      return state;
  }
}
